import React from 'react';
import { BlockUI } from 'primereact/blockui';
import { Dialog } from 'primereact/dialog';

const UserBlockedPopup = ({ open, data }) => {
  const title = data?.message || 'Account Blocked';

  return (
    <>
      <BlockUI blocked={open} fullScreen />
      <Dialog
        visible={open}
        closable={false}
        closeOnEscape={false}
        dismissableMask={false}
        draggable={false}
        resizable={false}
        modal
        onHide={() => {}}
        showHeader={false}
        className="user-blocked-popup"
        style={{ width: '30rem', maxWidth: '95vw' }}
        pt={{
          root: { className: 'border-none shadow-6' },
          content: { className: 'p-0 border-round-2xl overflow-hidden' },
        }}
      >
        <div className="text-center surface-card p-5">
          <div className="inline-flex align-items-center justify-content-center gap-2 mb-2">
            <i className="pi pi-lock text-red-500 text-sm" aria-hidden="true" />
            <span className="text-red-500 font-semibold text-sm uppercase letter-spacing-1">
              Access Restricted
            </span>
          </div>

          <h2 className="text-2xl font-bold text-900 m-0 mb-3 line-height-2">
            {title}
          </h2>

          <div className="flex align-items-start gap-3 text-left surface-100 border-round-xl p-3 border-1 border-200">
            <i
              className="pi pi-info-circle text-primary mt-1"
              style={{ fontSize: '1.125rem' }}
              aria-hidden="true"
            />
            <p className="text-700 text-sm line-height-3 m-0">
              You cannot continue using the application until your account is
              restored. Please reach out to your administrator for assistance.
            </p>
          </div>

          <div className="flex align-items-center justify-content-center gap-2 mt-4 text-500 text-sm">
            <span>Please contact your administrator</span>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default UserBlockedPopup;
